import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import parse from "html-react-parser";
import { Spin } from 'antd';
import Footer from '../component/Footer';
import { CalendarOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import logo from '../component/image/logo.png';

export default function BlogDetail() {
    const [news, setdataNews] = useState(null);
    const [loading, setLoading] = useState(true);
    const params = useParams();

    const getNews = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/getBySlug/${params?.slug}`);
            setdataNews(response?.data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getNews();
        window.scrollTo(0, 0);
    }, [params]);

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return d.toLocaleDateString('vi-VN', { day: '2-digit', month: 'long', year: 'numeric' });
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <>
            <div className="min-h-screen bg-[#0a1628]">
                {/* Hero Image */}
                <div className="relative h-[300px] md:h-[450px] overflow-hidden">
                    <img
                        src={news?.blog_image || logo}
                        alt={news?.blog_title}
                        className="w-full h-full object-cover"
                        crossOrigin="anonymous"
                        onError={(e) => { e.target.onerror = null; e.target.src = logo; }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-8">
                        <div className="max-w-screen-lg mx-auto">
                            <Link to="/blog" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-4 transition-colors text-sm">
                                <ArrowLeftOutlined /> Quay lại Blog
                            </Link>
                            <h1 className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-4">
                                {news?.blog_title}
                            </h1>
                            <div className="flex items-center gap-4 text-white/80">
                                <div className="flex items-center gap-2">
                                    <CalendarOutlined />
                                    <span>{formatDate(news?.create_at)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="max-w-screen-lg mx-auto px-6 py-12">
                    <article className="bg-[#0f1e35] border border-white/10 rounded-2xl p-8 md:p-12">
                        <div className="prose prose-lg max-w-none
                            [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:text-white [&_h1]:mt-8 [&_h1]:mb-4
                            [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-gray-100 [&_h2]:mt-6 [&_h2]:mb-3
                            [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-gray-200 [&_h3]:mt-5 [&_h3]:mb-2
                            [&_p]:text-gray-300 [&_p]:leading-relaxed [&_p]:mb-4
                            [&_img]:rounded-xl [&_img]:shadow-md [&_img]:my-6 [&_img]:mx-auto
                            [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4
                            [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4
                            [&_li]:text-gray-300 [&_li]:mb-2
                            [&_a]:text-blue-400 [&_a]:underline
                            [&_blockquote]:border-l-4 [&_blockquote]:border-blue-500 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:text-gray-400
                            [&_strong]:text-white
                        ">
                            {parse(String(news?.blog_description || ''))}
                        </div>
                    </article>

                    {/* Back link */}
                    <div className="mt-8 text-center">
                        <Link to="/blog" className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-xl transition-colors shadow-md">
                            <ArrowLeftOutlined /> Xem tất cả bài viết
                        </Link>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
